import type { IAuthorizationItem } from './authorization';
import type { InspectorDTO } from './dto/inspector.dto';
import type { IInspector } from './inspectors';
import type { IAllocatedInspector } from './solution';

export type { InspectorDTO };

export const mapInspectorDTOToInspector = (dto: InspectorDTO): IInspector => ({
  id: dto.id,
  name: dto.name,
  title: '',
  authorizations: [],
  appointments: [],
});

export const mapInspectorDTOToAllocatedInspector = (dto: InspectorDTO): IAllocatedInspector => ({
  id: dto.id,
  inspector: {
    id: dto.id,
    name: dto.name,
  },
  travelDistance: 0,
  slot: dto.slots || [],
});

export interface IInspectorItem {
  id: number | string;
  name: string;
  email?: string;
  phone?: string;
  roleId?: number;
  role?: MemberRole;
  country?: string;
  region?: string;
  address?: string;
  city?: string;
  postalCode?: string;
  notes?: string;
  teamId?: number;
  location?: string;
  authorizations?: IAuthorizationItem[];
  isNew?: boolean;
  type?: InspectorType;
  daysCapacity?: number;
  daysCapacityPeriod?: CapacityUnit;
  travelLimit?: number;
  status?: InspectorStatus;
  businessUnitId?: number | null;
  timezoneId?: string;
  dashboardLanguage?: string;
  communicationLanguages?: any[];
  preferredLanguage?: string;
  businessUnit?: {
    id: number;
    name: string;
  };
  user?: {
    id: number;
    name: string;
    email: string;
  };
  outlookConnectionStatus?: OutlookConnectionStatus;
  outlookConnectionHealth?: OutlookConnectionHealth;
  outlookCalendarEmail?: string | null;
  hasManualLeave?: boolean;
}

export enum OutlookConnectionStatus {
  CONNECTED = 'CONNECTED',
  NOT_CONNECTED = 'NOT_CONNECTED',
}

/**
 * Richer per-auditor Outlook connection health (mirrors the backend `InspectorConnectionHealth`).
 * Only HEALTHY is fully connected; the rest explain why an auditor is unhealthy.
 */
export enum OutlookConnectionHealth {
  HEALTHY = 'HEALTHY',
  NO_SUBSCRIPTION = 'NO_SUBSCRIPTION',
  SUBSCRIPTION_EXPIRED = 'SUBSCRIPTION_EXPIRED',
  SUBSCRIPTION_STALE = 'SUBSCRIPTION_STALE',
  MISSING_AT_GRAPH = 'MISSING_AT_GRAPH',
  NEEDS_REAUTH = 'NEEDS_REAUTH',
  NEEDS_ADMIN = 'NEEDS_ADMIN',
  NOT_MAPPED = 'NOT_MAPPED',
  INACTIVE = 'INACTIVE',
  UNKNOWN = 'UNKNOWN',
}

export interface IActivityInspector {
  id: number;
  inspector: IInspector;
  activityId: number;
}
export enum CapacityUnit {
  WEEK = 'WEEK',
  MONTH = 'MONTH',
}

export type AddressInfoType = {
  country: string;
  city: string;
  postalCode?: string;
  region: string;
  zipCode?: string;
};

export type MemberRole = {
  id: number;
  role: string;
};

export enum InspectorType {
  INTERNAL = 'INTERNAL',
  EXTERNAL = 'EXTERNAL',
}

export enum InspectorStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  INVITED = 'pending',
  SUSPENDED = 'suspended',
}
